/**
 * 活动所有的请求都放到这里，不准把ajax调用写到view或者别的模块
 */
import { get, post, getScript } from 'mihoyo-event-model';

const act_id = '?act_id=igdyocrbigdymirjag';

export default {
  getCookieToken: function(options = {}) {
    // return get(`https://test.account.mihoyo.com/Api/cookie_accountinfo_by_loginticket`, options);
    return get(`https://webapi.account.mihoyo.com/Api/cookie_accountinfo_by_loginticket`, options);
  },
  initial: function(options = {}) {
    return get(`index${act_id}`, options);
  },
  initialAward: function(options = {}) {
    return get(`showList${act_id}`, options);
  },
  getPornList: function(options = {}) {
    return get(`postList${act_id}`, options);
  },
  getPornDetail: function(options = {}) {
    return get(`postInfo${act_id}`, options);
  },
  like: function(options = {}) {
    return post(`like${act_id}`, options);
  },
  prePost: function(options = {}) {
    return get(`prePost${act_id}`, options);
  },
  upload: function(options = {}) {
    // return post(`https://devapi.mihoyo.com/event/bh3_works_collection/upload.php${act_id}`, options);
    return post(`https://upload.mihoyo.com/event/bh3_works_collection/upload.php${act_id}`, options);
  },
  submit: function(options = {}) {
    return post(`post${act_id}`, options);
  },
  myPornList: function(options = {}) {
    return get(`getUserPost${act_id}`, options);
  }
}
